import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router'
import { toSignal } from '@angular/core/rxjs-interop'
import { filter, map } from 'rxjs'
import {
  BricksAppFrameComponent,
  BricksSidebarComponent,
  BricksSidebarContainerComponent,
  BricksSidebarMenuItemComponent,
  BricksToolbarComponent,
  BricksUserMenuComponent,
} from '@enbw_bricks/ui'
import { AuthService } from '../auth/auth.service'
import { DevSettingsService } from '../dev-settings/dev-settings.service'
import { version } from '../../../../../../package.json'
import { environment } from '../../../environments/environment'
import { ScrollTopButtonComponent } from '../scroll-top-button/scroll-top-button.component'
import { FEATURE_FLAGS } from '../feature-flags/feature-flags'

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    BricksAppFrameComponent,
    BricksSidebarContainerComponent,
    BricksToolbarComponent,
    BricksSidebarComponent,
    BricksUserMenuComponent,
    BricksSidebarMenuItemComponent,
    RouterLink,
    ScrollTopButtonComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  readonly authService = inject(AuthService)
  readonly appVersion = version
  // hide stage name on prod builds
  readonly stagename = environment.production ? '' : environment.name.toUpperCase()
  readonly devMode = inject(DevSettingsService).isDevMode

  private readonly router = inject(Router)
  private readonly featureFlags = inject(FEATURE_FLAGS)

  get menuItems() {
    const portfolioItem = { title: 'Portfolio', routerPath: '/portfolio', iconName: 'bricks-folder' }
    const companyItem = { title: 'Unternehmen', routerPath: '/companies', iconName: 'bricks-company' }
    return this.featureFlags.isCompanyPortfolioFeaturesEnabled && this.authService.canManageCompanies()
      ? [portfolioItem, companyItem]
      : [portfolioItem]
  }

  private readonly activePath = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.router.url)
    ),
    { initialValue: this.router.url }
  )

  isActive(routerPath: string): boolean {
    return this.activePath().startsWith(routerPath)
  }

  navigateTo(routerPath: string): void {
    void this.router.navigate([routerPath])
  }

  async logout() {
    await this.authService.logout()
  }

  get userRole() {
    return this.authService.roleLabel
  }
}
